import styled, {ThemedStyledFunction} from 'styled-components';

interface Props {
    rtl?: boolean;
}

type StyledIFrame = ThemedStyledFunction<React.ComponentType<Props>, any, Props, any>;

const TaxRecordInterviewIframe = (styled.iframe as StyledIFrame)`
    border: 0;
    min-width: ${props => (props.rtl ? '860px' : '100%')};
    min-height: 800px;
    text-align:${props => (props.rtl ? 'right' : 'left')};;
    direction: ${props => (props.rtl ? 'rtl' : 'ltr')};
`;

TaxRecordInterviewIframe.displayName = 'TaxRecordInterviewIframe';

export default TaxRecordInterviewIframe;
